import * as React from 'react';
import { Editor } from '@tinymce/tinymce-react';
// Models
import { Editor as TinyMCEEditor } from 'tinymce';

import { IAllProps } from '@tinymce/tinymce-react';
const styles = require('./styles/TextEditor.css');

export interface ITextEditorComponentProps extends Partial<IAllProps> {
	/** selects different element to attach the editor to */
	selector?: any;
	/** show/hide the menu bar */
	menubar?: boolean;
	/** personalization tags custom dropdown */
	personalizationTags?: {
		buttonLabel: string;
		id: string;
		tags: IPersonalizationTag[];
	};
}
export interface IPersonalizationTag {
	label: string;
	value: string;
}
export const TextEditor: React.FC<ITextEditorComponentProps> = (props) => {
	const getSetup = (editor: TinyMCEEditor) => {
		props.personalizationTags &&
			editor.ui.registry.addMenuButton(props.personalizationTags.id, {
				fetch: (callback) => {
					const items: any =
						props.personalizationTags &&
						props.personalizationTags.tags.map((item: IPersonalizationTag) => {
							return {
								onAction: () => {
									editor.insertContent(item.value);
								},
								text: item.label,
								type: 'menuitem',
							};
						});
					callback(items);
				},
				text: props.personalizationTags.buttonLabel,
			});
	};
	const getToolbar = () => {
		if (props.personalizationTags) {
			return `${props.toolbar} | ${props.personalizationTags.id}`;
		}
		return props.toolbar;
	};
	return (
		<div className={styles.container}>
			<Editor
				{...props}
				apiKey="f3vo81k6z7efry5af62a1l5nm882r1dyrqn2df1cugtsofwq"
				toolbar={getToolbar()}
				init={{
					setup: props.personalizationTags ? getSetup : undefined,
					...props.init,
					menubar: props.menubar,
					selector: props.selector,
					toolbar_mode: 'wrap',
					skin: 'bootstrap',
					icons: 'material',
					branding: true,
					statusbar: true,
				}}
			/>
		</div>
	);
};

TextEditor.defaultProps = {
	// className: '',
	disabled: false,
	init: {},
	inline: false,
	menubar: false,
	plugins: [
		'lists advlist',
		'anchor',
		'autolink',
		'autoresize',
		'charmap',
		'code codesample',
		'directionality',
		'emoticons',
		'fullscreen',
		'help',
		'hr',
		'image imagetools',
		'insertdatetime',
		'link',
		'nonbreaking',
		'paste',
		'preview',
		'print',
		'quickbars',
		'searchreplace',
		'table',
		// 'template',
		'toc',
		'visualblocks',
		// 'wordcount',
		'textcolor',
	],
	// style: {},
	// toolbar: `bullist numlist | emoticons | code | image | anchor link | paste pastetext |
	// `
	toolbar: `formatselect fontselect fontsizeselect forecolor | bold italic underline | link unlink | numlist bullist | image | removeformat | emoticons `,
	// toolbar1: ' bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link image media preview ',
	// toolbar2: 'forecolor backcolor emoticons | jbimages ',
	// toolbar: [
	// 	`fontselect fontsizeselect forecolor | bold italic underline | link unlink`,
	// 	' numlist bullist | image | removeformat | emoticons ',
	// ],
};
TextEditor.displayName = 'TextEditor';
export default TextEditor;
